<template>
  <div class="basic-properties-v2">
    <div>
      
      <div class="left-align left right">
        <div class="inline" style="width:70%">
          <at-input v-if="editing" v-model="objectName"
          v-on:keyup.enter="switchEditing(false)" v-on:blur="switchEditing(false)" :autofocus="true"
          v-on:keyup.space="switchEditing(false)" v-on:keydown.enter="switchEditing(false)"
          placeholder="Placeholder name"></at-input>
          <div v-else class="heading is-changeable-text" v-on:click="switchEditing(true)">{{objectName}}</div>
        </div>
        <div class="inline">
          <i class="icon icon-copy clickable left" @click="duplicate"></i>
          <i class="icon icon-chevron-up clickable left" @click="moveUp"></i>
          <i class="icon icon-chevron-down clickable left" @click="moveDown"></i>
          <i class="icon icon-trash clickable left" @click="deleteObj"></i>
        </div>
      </div>
      
      <div class="vspace"></div>
      <div class="vspace-2"></div>      

      
      <div class="left-align">
        <div class="pitem left right small-width-2 inline">X</div> 
        <at-input v-model="x" class="pitem is-std-width inline" size="small"></at-input> 
        <div class="pitem more-left right small-width-2 inline">Y</div> 
        <at-input v-model="y" class="pitem is-std-width inline" size="small"></at-input>
      </div>
      
      <div class="vspace"></div>
      
      <div class="left-align">
        <div class="pitem left right small-width-2 inline">W</div> 
        <at-input v-model="w" class="pitem is-std-width inline" size="small"></at-input> 
        <div class="pitem more-left right small-width-2 inline">H</div> 
        <at-input v-model="h" class="pitem is-std-width inline" size="small"></at-input>
      </div>

      <div class="vspace"></div>
      
      <div class="left-align">
        <div class="pitem left right small-width-6 inline">Rotation</div> 
        <at-input v-model="angle" class="pitem small-width-10 inline" size="small"></at-input>
      </div>

      <div class="vspace"></div>

      <div class="left-align">
        <div class="pitem left right small-width-6 inline">Opacity</div> 
        <at-input v-model="alpha" class="pitem small-width-10 inline" size="small"></at-input>
      </div>

      <CharacteristicProperties
          v-bind:bObject="this.bObject" 
          v-bind:bScene="this.bScene"/>

      <div class="vspace"></div>
      <div class="vspace-2"></div>

      <!--No need to show visibility as of now
      <div class="left-align">
        <div>
          <div class="pitem left right inline small-width-6">Visibility</div> 
          <div class="pitem left right right-align inline"> {{visibilitySliderVal[0]}} to {{visibilitySliderVal[1]}} frames</div>
        </div>
        <div class="vspace"></div>
        <vue-slider class="pitem left right" v-model="visibilitySliderVal"
        :process-style="{'background-color': '#526780'}" :tooltip-style="{'background-color': '#526780'}"
        :enable-cross="false" :min="visibilitySliderRange[0]"
         :max="visibilitySliderRange[1]" ></vue-slider> 
      </div>-->
      
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import CharacteristicProperties from '../properties/CharacteristicProperties.vue';
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';
import { BObject } from '../../lib/bezieLib/Objects/BObject';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import { BMotionType } from '../../lib/bezieLib/Animations/BMotionEnums';
import { Scene } from '../../lib/bezieLib/Scene';

export default {
  name: 'BasicPropertiesV2',
  components: {
    //VueSlider,
    CharacteristicProperties
  },
  props: {
    bObject : BObject, 
    bScene : Scene
  },
  data: function(){
    return {
      objectName : "Placeholder name",
      editing : false,
      x : 0,
      y : 0,
      w : 0,
      h : 0,
      angle : 0,
      alpha : 100,
      visibilitySliderVal : [0,60],
      visibilitySliderRange: [0,100]
    }
  },
  watch: {
    bObject: function(newObj){
      if(newObj){
        this.init();
      }
    },
    objectName : function(val){
      if(this.bObject){
        this.bObject.name = this.objectName;
      }
    },
    x : function(val){
        this.updateCentre();
    },
    y: function(val){
        this.updateCentre();
    },
    w : function(val){
        this.updateWH();
    },
    h: function(val){
        this.updateWH();
    },
    angle : function(val){
        if(this.bObject){
            this.bObject.setAngle(this.angle);
        }
    },
    alpha : function(val){
      if(this.bObject){
        this.bObject.setOpacity(this.alpha/100);
      }
    },
    visibilitySliderVal : function(val){
        if(this.bObject){
            this.bObject.setFrameRange(this.visibilitySliderVal);
        }
    }
  },
  methods:{
    moveDown(){
      if(this.bScene){
        this.bScene.moveSelectedObjectByALayer(false);
      }
    },
    moveUp(){
      if(this.bScene){
        this.bScene.moveSelectedObjectByALayer(true);
      }
    },
    deleteObj(){
      if(this.bScene){
        this.bScene.deleteSelectedObject();
        this.$emit('onDeleteClicked', true);
      }
    },
    duplicate(){
      if(this.bScene){
        this.bScene.duplicateSelectedObject();
      }
    },
    switchEditing : function(on){
      this.editing = on;
    },
    updateCentre : function(){
        if(this.bObject){
            this.bObject.setCentre([this.x, this.y]);
        }
    },
    updateWH : function(){
        if(this.bObject){
            this.bObject.setWH([this.w, this.h]);
            //console.log("wh set to "+this.w+" "+this.h);
        }
    },
    onUpdate : function(obj){
        //console.log("on update called");
        if(obj) {
            this.init();
        }
    },
    init: function(){
        this.objectName = this.bObject.name
        this.x = this.bObject.centre[0]
        this.y = this.bObject.centre[1]
        this.w = this.bObject.wh[0]
        this.h = this.bObject.wh[1]
        this.angle = this.bObject.angle
        this.alpha = this.bObject.opacity * 100
        this.visibilitySliderRange = this.bScene.getFrameRange()
        this.visibilitySliderVal = this.bObject.getFrameRange()
    }
  },
  mounted: function(){
      if(this.bObject){
        this.init();
        UIUpdate.addObjectUpdateListener(this);
      } 
  },
  beforeDestroy: function(){
    if(this.bObject){
      UIUpdate.removeObjectUpdateListener(this);
    }
  }
}
</script>

<style>
.heading{
  font-size: 20px;
}

.is-changeable-text{
  cursor: text;
}

.section{
  font-size: 16px;
}

.inline{
  display: inline-block;
}

.left-align{
    text-align: left;
}

.right-align{
    text-align: right;
}

.pitem{
  vertical-align: middle;
}

.vspace{
  height: 8px;
  width: 100%;
}

.vspace-2{
  height: 4px;
  width: 100%;
}

.left{
  margin-left: 10px;
}

.more-left{
  margin-left: 20px;
}

.right{
  margin-right: 10px;
}

.is-std-width{
  width: 140px;
}

.is-std-width-2{
  width: 120px;
}

.is-std-width-4{
  width: 80px;
}

.small-width-2{
  width: 20px;
}

.small-width-4{
  width: 40px;
}

.small-width-6{
  width: 60px;
}

.small-width-8{
  width: 80px;
}

.small-width-10{
  width: 100px;
}

.clickable{
  cursor: pointer;
}

</style>